module.exports = __webpack_public_path__ + "fonts/Manrope-400-latin6_e85a026.woff2";